module.exports = __webpack_public_path__ + "img/referto-4.20691fc8.jpg";